import { MutableRefObject, useEffect } from "react";
import { AutocompleteResult } from "components/FindYourCruise/Components/Autocomplete/useAutocomplete";

// NOTE: Check Algolia docs
// https://www.algolia.com/doc/ui-libraries/autocomplete/guides/creating-a-renderer/#mirroring-a-native-mobile-experience

type Args = {
  domRefs: {
    formRef: MutableRefObject<HTMLFormElement | null>;
    inputRef: MutableRefObject<HTMLInputElement | null>;
    containerRef: MutableRefObject<HTMLDivElement | null>;
    panelRef: MutableRefObject<HTMLDivElement | null>;
  };
  isAutocompleteOpen: boolean;
  getEnvironmentProps: AutocompleteResult["getEnvironmentProps"];
};

export const useEnableMobileKeyboardUX = ({
  domRefs,
  isAutocompleteOpen,
  getEnvironmentProps
}: Args) => {
  const { formRef, inputRef, containerRef, panelRef } = domRefs;

  useEffect(() => {
    if (!formRef.current || !panelRef.current || !inputRef.current) {
      return undefined;
    }

    const { onTouchStart, onTouchMove, onMouseDown } = getEnvironmentProps({
      formElement: formRef.current,
      inputElement: inputRef.current,
      panelElement: panelRef.current,
      container: containerRef
    });

    window.addEventListener("mousedown", onMouseDown);
    window.addEventListener("touchstart", onTouchStart);
    window.addEventListener("touchmove", onTouchMove);

    return () => {
      window.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
    };
  }, [getEnvironmentProps, isAutocompleteOpen]);
};
